module.exports = __webpack_public_path__ + "img/img_teacher1.2340f446.png";